module.exports = __webpack_public_path__ + "static/media/SearchIcon.d2a53ecf.png";